import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import { exportToCsv } from '@/lib/exportCsv';

const COLS = [
  { key: 'type', label: 'Type' }, { key: 'order_number', label: 'Order #' }, { key: 'table_number', label: 'Table' },
  { key: 'check_label', label: 'Check' }, { key: 'item', label: 'Item' }, { key: 'quantity', label: 'Qty' },
  { key: 'amount', label: 'Amount' }, { key: 'reason', label: 'Reason' }, { key: 'by', label: 'User' },
  { key: 'approved_by', label: 'Approved by' }, { key: 'at', label: 'Date/Time' },
];
const fmtAt = (v) => (v ? new Date(v).toLocaleString() : '');

// Day Report tab: voided bills + kitchen-item cancellations from existing order records.
export function DayCancellationsSection({ data, label = 'day', currency = 'SAR' }) {
  const bills = (data?.bills || []).map((b) => ({ ...b, type: 'Void bill', item: 'Whole bill', by: b.voided_by }));
  const items = (data?.items || []).map((i) => ({ ...i, type: 'Item cancel', by: i.cancelled_by }));
  const rows = [...bills, ...items].sort((a, b) => String(b.at).localeCompare(String(a.at)));
  return (
    <div className="space-y-3" data-testid="day-cancellations-section">
      <div className="grid grid-cols-2 gap-2 text-sm">
        <div className="rounded-lg border p-2" data-testid="day-cancel-bills-total">
          <div className="text-xs text-muted-foreground">Voided bills ({bills.length})</div>
          <div className="font-bold">{currency} {(data?.bills_total || 0).toFixed(2)}</div>
        </div>
        <div className="rounded-lg border p-2" data-testid="day-cancel-items-total">
          <div className="text-xs text-muted-foreground">Cancelled items ({items.length})</div>
          <div className="font-bold">{currency} {(data?.items_total || 0).toFixed(2)}</div>
        </div>
      </div>
      <Button size="sm" variant="outline" className="h-10 w-full" disabled={!rows.length}
        onClick={() => exportToCsv(`cancellations-voids-${label}`, rows.map((r) => ({ ...r, at: fmtAt(r.at) })), COLS)}
        data-testid="day-cancel-export-btn">
        <Download className="w-4 h-4 mr-2" /> Export CSV
      </Button>
      {!rows.length && <p className="text-sm text-muted-foreground text-center py-4" data-testid="day-cancel-empty">No cancellations or voids.</p>}
      <div className="space-y-2">
        {rows.map((r, i) => (
          <div key={i} className="rounded-lg border p-2 text-xs" data-testid={`day-cancel-row-${i}`}>
            <div className="flex justify-between font-semibold">
              <span>{r.type}{r.order_number ? ` · #${r.order_number}` : ''}{r.table_number ? ` · Table ${r.table_number}` : ''}{r.check_label ? ` · ${r.check_label}` : ''}</span>
              <span>{r.amount != null ? `${currency} ${Number(r.amount).toFixed(2)}` : '—'}</span>
            </div>
            <div>{r.type === 'Item cancel' ? `${r.quantity} × ${r.item}` : 'Whole bill'} — {r.reason || 'no reason'}</div>
            <div className="text-muted-foreground">By {r.by || '—'} · Approved {r.approved_by || '—'} · {fmtAt(r.at)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
